import { useTranslation } from 'react-i18next';
import { ProjectLockup } from './ProjectLockup';

/** The session could not be checked (offline, rate-limited or a server error). Not a sign-out: the check retries on
 *  its own (and on reconnect / returning to the app), and the person can retry now. Same card as WorkspaceLoading. */
export function SessionUnavailable({ onRetry }: { onRetry: () => void }) {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-dvh items-center justify-center bg-canvas px-6" role="status" aria-live="polite">
      <div className="flex w-full max-w-sm flex-col items-center rounded-[1.75rem] border border-default bg-surface px-8 py-10 text-center shadow-sm">
        <ProjectLockup variant="hero" />
        <p className="mt-8 text-sm font-semibold text-primary">{t('auth.session_unavailable_title')}</p>
        <p className="mt-2 text-sm text-secondary">{t('auth.session_unavailable_body')}</p>
        <button
          type="button"
          onClick={onRetry}
          className="mt-6 h-11 rounded-full bg-primary px-6 text-sm font-semibold text-on-primary transition-opacity hover:opacity-90
            focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
        >
          {t('auth.retry_now')}
        </button>
      </div>
    </main>
  );
}
